module.exports = __webpack_public_path__ + "img/bg-charm.8d067ba9.png";